import {ViewPersonalConfig} from "../../@type";
import {ViewType} from "../../../../gd/const/views/view-type";
import {PersonalViewLocation} from "../@types";

export const MY_DOCUMENTS_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_DOCUMENTS,
    name            : 'Documents',
    icon            : 'i5-my-documents',
    iconSvg         : 'isvg-view-documents',
    url             : 'my-documents',
    description     : 'All your documents in list view',
    defaultLocation : PersonalViewLocation.HOME_MORE

}
